export default __webpack_public_path__ + "7d4ff4f403ad6f087a17ef788c217138.png";